import React, { Component } from "react";
import Gallery from "react-photo-gallery";
import Lightbox from "react-images";

import Sunset from "../components/Sunset";

import "../styles/Gallery.css";

import bbr1 from "../images/photos/bbr1.jpg";
import bbr2 from "../images/photos/bbr2.jpg";
import bbr3 from "../images/photos/bbr3.jpg";
import ivy1 from "../images/photos/ivy1.jpg";
import ivy2 from "../images/photos/ivy2.jpg";
import ivy3 from "../images/photos/ivy3.jpg";
import crayho1 from "../images/photos/crayho1.jpg";
import crayho2 from "../images/photos/crayho2.jpg";
import bbr1b from "../images/photos/bbr1b.jpg";
import bbr3b from "../images/photos/bbr3b.jpg";
import bbr4b from "../images/photos/bbr4b.jpg";
import steampunk1 from "../images/photos/steampunk1.jpg";
import steampunk2 from "../images/photos/steampunk2.jpg";
import wc1 from "../images/photos/wc1.jpg";
import wc2 from "../images/photos/wc2.jpg";
import wc3 from "../images/photos/wc3.jpg";
import wc4 from "../images/photos/wc4.jpg";
import wc5 from "../images/photos/wc5.jpg";
import honeyisland1 from "../images/photos/honeyisland1.jpg";
import brick1 from "../images/photos/brick1.jpg";
import haight1 from "../images/photos/haight1.jpg";
import haight2 from "../images/photos/haight2.jpg";
import haight3 from "../images/photos/haight3.jpg";
import haight4 from "../images/photos/haight4.jpg";

const photos = [
    {
        src: bbr1,
        width: 5.2,
        height: 3.5,
    },
    {
        src: bbr2,
        width: 5.2,
        height: 3.5,
    },
    {
        src: bbr3,
        width: 5.2,
        height: 3.5,
    },
    {
        src: ivy1,
        width: 5.2,
        height: 3.5,
    },
    {
        src: ivy2,
        width: 5.2,
        height: 3.5,
    },
    {
        src: ivy3,
        width: 3.5,
        height: 5.2,
    },
    {
        src: crayho1,
        width: 3.3,
        height: 2.4,
    },
    {
        src: crayho2,
        width: 3.3,
        height: 1.8,
    },
    {
        src: bbr1b,
        width: 5.2,
        height: 3.5,
    },
    {
        src: bbr3b,
        width: 5.2,
        height: 3.5,
    },
    {
        src: bbr4b,
        width: 5.2,
        height: 3.5,
    },
    {
        src: steampunk1,
        width: 4.0,
        height: 3.0,
    },
    {
        src: steampunk2,
        width: 9.6,
        height: 9,
    },
    {
        src: wc1,
        width: 1.6,
        height: 1.1,
    },
    {
        src: wc2,
        width: 6,
        height: 9,
    },
    {
        src: wc3,
        width: 2,
        height: 1.5,
    },
    {
        src: wc4,
        width: 2.0,
        height: 1.3,
    },
    {
        src: wc5,
        width: 2.0,
        height: 1.9,
    },
    {
        src: honeyisland1,
        width: 9.6,
        height: 7.2,
    },
    {
        src: brick1,
        width: 1.5,
        height: 2.0,
    },
    {
        src: haight1,
        width: 1.5,
        height: 2.0,
    },
    {
        src: haight2,
        width: 7.9,
        height: 5.3,
    },
    {
        src: haight3,
        width: 8.0,
        height: 5.3,
    },
    {
        src: haight4,
        width: 8,
        height: 6,
    },
];

class Photos extends Component {
    constructor() {
        super();
        this.state = { currentImage: 0 };
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
    }
    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });
    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }
    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }
    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }
    render() {
        return (
            <div>
                <Sunset />
                <div className="gallery">
                    <Gallery
                        photos={photos}
                        margin={5}
                        onClick={this.openLightbox}
                    />
                    <Lightbox
                        images={photos}
                        onClose={this.closeLightbox}
                        onClickPrev={this.gotoPrevious}
                        onClickNext={this.gotoNext}
                        currentImage={this.state.currentImage}
                        isOpen={this.state.lightboxIsOpen}
                    />
                </div>
            </div>
        );
    }
}

export default Photos;



// WEBPACK FOOTER //
// ./src/components/Photos.js